export default () => ({
	isOpen: false,
	current: false,
	toggle() {
		this.isOpen = !this.isOpen;
	},
	setCurrent(index) {
		this.current = this.current === index ? false : index;
	}
})
